/*=========================================================================================
  File Name: sidebarItems.js
  Description: Sidebar Items list. Add / Remove menu items from here.
  Strucutre:
          url     => router path
          name    => name to display in sidebar
          slug    => router path name
          icon    => Feather Icon component/icon name
          tag     => text to display on badge
          tagColor  => class to apply on badge element
          i18n    => Internationalization
          submenu   => submenu of current item (current item will become dropdown )
                NOTE: Submenu don't have any icon(you can add icon if u want to display)
          isDisabled  => disable sidebar item/group
  ----------------------------------------------------------------------------------------*/

function getSiteId() {
  var userSiteInfo = localStorage.getItem('userSiteInfo');
  if(localStorage.getItem('userSiteInfo') != ""){
    if(JSON.parse(localStorage.getItem('userSiteInfo')) instanceof Array)
      return JSON.parse(localStorage.getItem('userSiteInfo'))[0].siteId;
    else 
      return JSON.parse(localStorage.getItem('userSiteInfo')).siteId;
  }
  else
    return 0;
}

function getItems(){
  var items = [{
      url: '/digi/dashboard',
      name: "Dashboard",
      slug: "Dashboard",
      icon: "BookIcon",
      i18n: "Dashboard",
    },  
    {
      url: '/digi/teacher',
      name: "My Subjects",
      slug: "TeacherSubjects",
      icon: "BookIcon",
      i18n: "TeacherSubjects",
    },
    {
        url: '/digi/teacher/browsecontent',
        name: "My Content",
        slug: "TeacherBrowseContent",
        icon: "ArchiveIcon",
        i18n: "TeacherBrowseContent",
    },
    {
        url: '/digi/teacher/resources',
        name: "My Resources",
        slug: "TeacherResources",
        icon: "FolderIcon",
        i18n: "TeacherResources",
    },
    {
        url: '/digi/teacher/calendar',
        name: "My Calendar",
        slug: "TeacherCalendar",
        icon: "CalendarIcon",
        i18n: "TeacherCalendar",
    },
    {
        url: '/digi/teacher/library',
        name: "Manage Library",
        slug: "TeacherLibrary",
        icon: "BookOpenIcon",
        i18n: "TeacherLibary",
    },
    
  ];

  var siteId = getSiteId();
  if((process.env.NODE_ENV === 'production' && siteId == 21) || (process.env.NODE_ENV !== 'production')){
      items.push(
        {
          url: '/digi/teacher/assessment',
          name: "Markable Activities",
          slug: "TeacherAssessments",
          icon: "EditIcon",
          i18n: "TeacherAssessments",
      },
    );
  }else{
    items.push(
      {
        url: '/digi/teacher/assessment',
        name: "My Assessments",
        slug: "TeacherAssessments",
        icon: "EditIcon",
        i18n: "TeacherAssessments",
    },
  );
  }

  var QASitesActive = [21,24];//swales,ligbron
  if((process.env.NODE_ENV === 'production' && QASitesActive.includes(siteId)) || (process.env.NODE_ENV !== 'production')){
      items.push(
      {
        url: '/digi/teacher/qa',
        name: "Q/A",
        slug: "TeacherQA",
        icon: "SmileIcon",
        i18n: "TeacherQA",
      }
    );
  }

  return items;
}

export default getItems();